import { pxToRem } from '../../helpers'
import { StyleFn } from '..'

export const Toast: StyleFn = ({ color, elevation, font, responsive, size }) => ({
  root: {
    zIndex: elevation.zindex.banner,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: pxToRem(328),
    minHeight: size.spacing[56],
    fontSize: font.size.small,
    fontWeight: font.weight.regular,
    lineHeight: font.lineheight.small,
    color: color.getModalValues(color.text.primary),
    backgroundColor: color.type === 'light' ? color.palette.white : color.palette.warmgrey[100],
    padding: size.spacing[16],
    paddingLeft: size.spacing[24],
    borderRadius: 3,
    boxShadow: elevation.level3,
    overflow: 'hidden',
    position: 'relative',
    '&:before': {
      position: 'absolute',
      content: "''",
      top: 0,
      left: 0,
      bottom: 0,
      width: size.spacing[8],
      backgroundColor: color.background.interactive.info.default,
    },
    [`@media (max-width: ${responsive.breakpoint.xs}px)`]: { width: '100%' },
  },
  heading: {
    fontSize: font.size.medium,
    fontWeight: font.weight.bold,
    '& ~ $body': {
      paddingTop: size.spacing[8],
    },
  },
  time: {
    position: 'absolute',
    top: size.spacing[16],
    right: size.spacing[16],
    fontSize: font.size.xsmall,
    lineHeight: font.lineheight.medium,
    color: color.type === 'light' ? color.palette.coolgrey[60] : color.palette.coolgrey[30],
  },
  body: {},
  removeBtn: {
    // increase specificity
    '&$removeBtn': { position: 'absolute' },
    top: '50%',
    right: size.spacing[8],
    transform: 'translate(0, -50%)',
  },
  _inline: {
    width: pxToRem(600),
    [`@media (max-width: ${responsive.breakpoint.sm}px)`]: { width: '100%' },
  },
  _withRemove: {
    paddingRight: size.spacing[64],
    '& $time': {
      right: size.spacing[80],
    },
    '&:after': {
      position: 'absolute',
      content: "''",
      top: size.spacing[8],
      right: size.spacing[48],
      bottom: size.spacing[8],
      width: 1,
      backgroundColor: color.type === 'light' ? color.palette.coolgrey[30] : color.palette.coolgrey[60],
    },
  },
  _info: {},
  _success: {
    '&:before': {
      backgroundColor: color.background.interactive.success.default,
    },
  },
  _warning: {
    '&:before': {
      backgroundColor: color.background.interactive.warning.default,
    },
  },
  _error: {
    '&:before': {
      backgroundColor: color.background.interactive.error.default,
    },
  },
})
